import React from "react";
import Slider from "react-slick";
import "../../assets/css/slick.css";
import "../../assets/css/slick-theme.css";
import getTestimonialData from "./TestimonialData.json";
import TestimonialCard from "./TestimonialCard";
import TestimonialSectionTitle from "../section-title/TestimonialSectionTitle";
import {TestimonialCarouselConfig} from "../../includes/scripts";

const Testimonial = () => {
    return (
        <>
            {/* Testimonial Section Start */}
            <div className="testimonial-sec pt-100 pb-100"
                 style={{ backgroundImage:`url(${require('../../assets/images/testimonial_bg.png')})` }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <TestimonialSectionTitle
                            subTitle="What Our Clients Say"
                            title="<span>Client</span> Testimonials"
                            content="<p>Don't just take our word for it. Hear from businesses and individuals across Turkey who trust Iron Wall X to protect their assets, employees, and families. Our commitment to excellence has earned us hundreds of satisfied clients nationwide.</p>"
                            btnText="Contact Us"
                            btnLink="/contact-us"
                            />
                        </div>
                        <div className="col-md-8 no-padding">
                            <Slider
                                className="all-testimonial2"
                                {...TestimonialCarouselConfig}
                            >
                                {
                                    getTestimonialData.map((item) => (
                                        <TestimonialCard
                                        key={item.id}
                                        data={item}
                                        />
                                    ))
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            {/* Testimonial Section End */}
        </>
    );
}

export default Testimonial;